import { JsonProperty } from 'json-typescript-mapper';

export class Document {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('title')
  public title?: string;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('updated')
  public updated?: string;

  @JsonProperty('hash')
  public hash?: string;

  @JsonProperty('active')
  public active?: boolean;

  @JsonProperty('categoryId')
  public categoryId?: any;

  @JsonProperty('sortOrder')
  public sortOrder?: number;

  constructor() {
    this.id = void 0;
    this.title = void 0;
    this.created = void 0;
    this.updated = void 0;
    this.hash = void 0;
    this.active = void 0;
    this.categoryId = void 0;
    this.sortOrder = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/document.model.ts